import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import styles from './CustomDnd.module.scss'

let catchedEl = null
let clickOffset = null
let parentNormalize = null
let onDndHandler = null

function onMouseDown(ev) {
    if ((ev.button === 0 || ev.type === 'touchstart') && ev.target.dataset.draggable) {
        catchedEl = ev.target

        let { clientX, clientY } = ev

        if (ev.type === 'touchstart') {
            clientX = ev.changedTouches[0].clientX
            clientY = ev.changedTouches[0].clientY
        }

        const { top, left } = catchedEl.getBoundingClientRect()

        clickOffset = {
            top: clientY - top,
            left: clientX - left,
        }

        parentNormalize = {
            top: top - catchedEl.offsetTop,
            left: left - catchedEl.offsetLeft,
        }
    }
}

function onMouseMove(ev) {
    if (catchedEl) {
        let { clientX, clientY } = ev

        if (ev.type === 'touchmove') {
            clientX = ev.changedTouches[0].clientX
            clientY = ev.changedTouches[0].clientY
        }

        catchedEl.style.top = `${clientY - parentNormalize.top - clickOffset.top}px`
        catchedEl.style.left = `${clientX - parentNormalize.left - clickOffset.left}px`
    }
}

function onMouseUp() {
    if (catchedEl) {
        const droppableElList = window.document.querySelectorAll('#custom-dnd [data-droppable]')

        const { left, top, width, height } = catchedEl.getBoundingClientRect()
        const centerX = left + width / 2
        const centerY = top + height / 2

        for (let i = 0; i < droppableElList.length; i += 1) {
            const droppableEl = droppableElList[i]
            const { left, top, right, bottom } = droppableEl.getBoundingClientRect()
            const { draggable } = catchedEl.dataset
            const { droppable } = droppableEl.dataset

            if (draggable === droppable && left <= centerX && centerX <= right && top <= centerY && centerY <= bottom) {
                releaseCatchedEl()
                onDndHandler(draggable, droppable)

                return
            }
        }

        releaseCatchedEl()
    }
}

function onMouseLeave() {
    releaseCatchedEl()
}

function releaseCatchedEl() {
    if (catchedEl) {
        catchedEl.style.top = null
        catchedEl.style.left = null

        catchedEl = null
        clickOffset = null
        parentNormalize = null
    }
}

function CustomDnd({ className, onDropped, children }) {
    useEffect(() => {
        catchedEl = null
    }, [])

    useEffect(() => {
        onDndHandler = onDropped
    }, [onDropped])

    return (
        <div
            id="custom-dnd"
            className={classNames(className, styles.wrapper)}
            onMouseDown={onMouseDown}
            onTouchStart={onMouseDown}
            onMouseMove={onMouseMove}
            onTouchMove={onMouseMove}
            onMouseUp={onMouseUp}
            onTouchEnd={onMouseUp}
            onMouseLeave={onMouseLeave}
            onTouchCancel={onMouseLeave}
            aria-hidden
        >
            {children}
        </div>
    )
}

CustomDnd.propTypes = {
    className: PropTypes.string,
    onDropped: PropTypes.func.isRequired,
    children: PropTypes.any,
}

export { CustomDnd }
